import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {APIClient} from "../../../utils/APIClient";
import {API_URL} from "../../../settings/local_settings";
import {SpinnerButton} from "../../SpinnerButton";
import {isNetworkError, isOk} from "../../../utils/apiResponse";
import { Trans, withTranslation } from 'react-i18next';

// Errores tipados del backend que se muestran con el texto de acá (y en el idioma del usuario)
// en vez del `error_message` del servidor, que viene siempre en español.
const ERROR_MESSAGE_KEYS = {
    VTEX_INVALID_ACCOUNT_NAME: 'vtex.invalid_account_name',
};

// Los dominios de la ayuda y del error van en negrita para que se separen de la prosa
// (QA-VIS-vtex-07): `<b>` en las claves de i18n.
const DOMAIN_MARKUP = {b: <b/>};

// El mismo tamaño y aire que los carteles de las hermanas (Klaviyo, WooCommerce). `textWrap`
// evita que la última línea quede con una sola palabra (QA-VIS-vtex-12).
const ALERT_STYLE = { fontSize: '0.9em', marginTop: '1em', marginBottom: 0, textWrap: 'pretty' };

class AddVtexStoreFormClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accountName: '',
            apiKey: '',
            apiToken: '',
            loading: false,
            error: null,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        const { t } = this.props;
        const accountName = this.state.accountName.trim();
        const apiKey = this.state.apiKey.trim();
        const apiToken = this.state.apiToken.trim();

        if (!accountName) {
            this.setState({ error: t('vtex.account_name_required') });
            return;
        }

        if (!apiKey) {
            this.setState({ error: t('vtex.api_key_required') });
            return;
        }

        if (!apiToken) {
            this.setState({ error: t('vtex.api_token_required') });
            return;
        }

        this.setState({ loading: true, error: null });

        new APIClient(API_URL + 'get_access_tokens/vtex/').call('POST', {
            account_name: accountName,
            api_key: apiKey,
            api_token: apiToken,
        }).then((response) => {
            // `!isOk`, no `status === 'ERROR'`: un error tipado (VTEX_INVALID_ACCOUNT_NAME) o el
            // NETWORK_ERROR del APIClient caían en la rama de éxito y cerraban el modal sin conectar.
            if (!isOk(response)) {
                this.setState({ loading: false, error: this.errorMessageOf(response) });
                return;
            }
            this.setState({ loading: false });
            this.props.afterSuccessfulSubmit(response.data);
        }).catch(() => {
            this.setState({
                loading: false,
                error: t('vtex.connection_error'),
            });
        });
    }

    errorMessageOf(response) {
        const { t } = this.props;
        if (isNetworkError(response)) {
            return t('vtex.connection_error');
        }
        const key = ERROR_MESSAGE_KEYS[response.error_code];
        return key ? <Trans t={t} i18nKey={key} components={DOMAIN_MARKUP}/> : response.error_message;
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <ModalBody>
                    <div className="modal-section">
                        <p>{t('vtex.connect_description')}</p>
                        <div className="form-row">
                            <label htmlFor="vtex-account-name">{t('vtex.account_name_label')}</label>
                            <input
                                id="vtex-account-name"
                                type="text"
                                className="form-control"
                                placeholder={t('vtex.account_name_placeholder')}
                                value={this.state.accountName}
                                onChange={(e) => this.setState({ accountName: e.target.value, error: null })}
                            />
                        </div>
                        <div className="form-row">
                            <label htmlFor="vtex-api-key">{t('vtex.api_key_label')}</label>
                            <input
                                id="vtex-api-key"
                                type="text"
                                className="form-control"
                                placeholder={t('vtex.api_key_placeholder')}
                                value={this.state.apiKey}
                                onChange={(e) => this.setState({ apiKey: e.target.value, error: null })}
                            />
                        </div>
                        <div className="form-row">
                            <label htmlFor="vtex-api-token">{t('vtex.api_token_label')}</label>
                            <input
                                id="vtex-api-token"
                                type="password"
                                className="form-control"
                                placeholder={t('vtex.api_token_placeholder')}
                                value={this.state.apiToken}
                                onChange={(e) => this.setState({ apiToken: e.target.value, error: null })}
                            />
                        </div>
                        {/* Dónde está el nombre de cuenta, ANTES del primer intento: sin esto la pista
                            aparecía recién al equivocarse (QA-VIS-vtex-06). */}
                        <div className="alert alert-info" style={ALERT_STYLE}>
                            <Trans t={t} i18nKey="vtex.account_name_help" components={DOMAIN_MARKUP}/>
                        </div>
                        {this.state.error && (
                            <div className="alert alert-danger" role="alert" style={ALERT_STYLE}>
                                {this.state.error}
                            </div>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.state.loading ? (
                        <SpinnerButton />
                    ) : (
                        <button
                            className="btn -alt"
                            onClick={this.handleSubmit}
                        >
                            {t('vtex.connect_button')}
                        </button>
                    )}
                </ModalFooter>
            </div>
        );
    }
}

export const AddVtexStoreForm = withTranslation()(AddVtexStoreFormClass);
